/**
 * 판매자 예외정책 필드
 * > 현재는 CAR_GENERAL_SALE 과 관련된 정책만 FE에서 관리중
 */
export const MerchantExceptionPolicy = {
    DISPATCH_DUE_DATE: 'DISPATCH_DUE_DATE',
    ADD_ADMIN_REVIEW_BENEFIT: 'ADD_ADMIN_REVIEW_BENEFIT',
    RELIEFPHONE_NUMBER_NOT_USED: 'RELIEFPHONE_NUMBER_NOT_USED',
    COOL_BAG: 'COOL_BAG',
    EXCEPT_MEMBERSHIP_BENEFIT: 'EXCEPT_MEMBERSHIP_BENEFIT',
    REALTIME_PRODUCT: 'REALTIME_PRODUCT',
    ECOUPON_BARCODE_CONNECT: 'ECOUPON_BARCODE_CONNECT',
    CAR_GENERAL_SALE: 'CAR_GENERAL_SALE',
} as const

export type MerchantExceptionPolicyType = Constant<typeof MerchantExceptionPolicy>
